import 'react-datepicker/dist/react-datepicker.css';

import { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';

import ImageComponent from '../../image';
import TextPrompt from '../text-prompt';

interface IInput extends React.ComponentPropsWithoutRef<'input'> {
	label?: string;
	error?: string | undefined;
	isonlyview?: boolean;
	minComponent?: boolean;
	imageUrl?: string;
	dateOnChange?: (date: Date | null) => void;
	dateValue?: Date | null;
	minDate?: Date | null;
	maxDate?: Date | null;
}

export const TypeDateInput = forwardRef(
	({ label, error, isonlyview, minComponent, imageUrl, dateOnChange, dateValue, minDate, maxDate, ...props }: IInput, _ref) => (
		<InputComponent className={props.className || ''}>
			<div className={`form-container position-relative ${props.className || ''}`}>
				{label || imageUrl ? (
					<div className='f-row-17 align-items-center pb-2'>
						{imageUrl && (
							<ImageComponent
								src={imageUrl}
								alt='logo'
								style={{
									width: '25px',
									height: '25px',
									objectFit: 'contain',
								}}
							/>
						)}
						{label && (
							<label
								htmlFor={props.id || props.name}
								className='m-0'
							>
								{label}
							</label>
						)}
					</div>
				) : null}
				<DatePicker
					selected={dateValue}
					onChange={dateOnChange}
					minDate={minDate ?? undefined}
					maxDate={maxDate ?? undefined}
					dateFormat='dd/MM/yyyy'
					placeholderText='DD/MM/YYYY'
					disabled={props.disabled || isonlyview}
					className={`${error ? 'is-error' : ''} ${isonlyview ? 'isonlyview' : ''} ${minComponent ? 'min-size' : ''}`}
				/>
				{!!error && (
					<TextPrompt
						prompt={error}
						status={false}
					/>
				)}
			</div>
		</InputComponent>
	)
);

TypeDateInput.displayName = 'TypeDateInput';

const InputComponent = styled.div`
	.react-datepicker-wrapper {
		width: 100%;
	}
	input {
		width: 100%;
		height: 3.125rem;
		background: none;
		border: 1px solid #a1a1a1;
		border-radius: 0.1875rem;
		padding: 0 1.24rem 0 0.6rem;
		box-shadow: none;
		box-sizing: border-box;
		outline: none;
		&::placeholder {
			color: var(--input-placeholder, #a1a1a1);
			font-size: 0.8125rem;
			font-style: normal;
			font-weight: 300;
			line-height: normal;
		}
		&:focus {
			&.is-error {
				border: 1px solid #f56e9d;
			}
		}
		&.is-error {
			border: 1px solid #f56e9d;
			margin-bottom: 0.81rem;
		}
		&.isonlyview {
			padding-left: 0;
			border: none;
		}
		&.min-size {
			font-size: 12px;
			height: 40px;
			border: 1px solid #d1d1d1;

			@media (max-width: 768px) {
				font-size: 16px;
			}
		}
	}
`;
